import { useEffect, useRef, type ReactNode } from "react";

/**
 * Focus-trapped dialog using the native <dialog> element (escapes stacking contexts,
 * traps focus, Escape closes, focus returns to the trigger automatically).
 */
export function Modal({
  open,
  onClose,
  title,
  children,
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}) {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);

  return (
    <dialog
      className="modal"
      ref={ref}
      aria-label={title}
      onCancel={onClose}
      onClose={onClose}
    >
      <h2>{title}</h2>
      {children}
    </dialog>
  );
}
